import { Typography } from "@creditsafe/ui-components";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box, Menu, MenuItem } from "@mui/material";
import { camelCase } from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import StatusCircle from "../../../shared/components/status-circle/StatusCircle";
import { CenteredBox } from "../../../shared/styles/common-styles";

export const KYCStatus: React.FC<{
  header: string;
  kycStatus: string[];
  index: string;
  updateChipLabels: (key: string, value: string) => void;
  selectedStatus: (status: string[]) => void;
  statusToDelete: string[];
  statuses?: string[];
}> = ({
  header,
  kycStatus,
  index,
  updateChipLabels,
  selectedStatus,
  statuses,
}) => {
  const { t: translate } = useTranslation(["profile", "common"]);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openPopoverId, setOpenPopoverId] = useState<string | null>(null);
  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorEl(event.currentTarget);
    setOpenPopoverId(id);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setOpenPopoverId(null);
  };

  const handleSelectedStatus = (status: string) => {
    updateChipLabels(
      "kycStatus",
      `KYC Status:` + ` ` + status.charAt(0).toUpperCase() + status.slice(1)
    );
    selectedStatus([status]);
    setAnchorEl(null);
    setOpenPopoverId(null);
  };

  return (
    <Box component={"span"}>
      <Typography
        key={index}
        aria-label="kyc status"
        variant="h6"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
          handlePopoverOpen(e, header)
        }
      >
        <CenteredBox aria-label="kycStatusValue">
          {translate(header)}
          {openPopoverId === header || (statuses && statuses.length > 0) ? (
            <FilterAltIcon fontSize="small" />
          ) : (
            <FilterAltOutlinedIcon fontSize="small" />
          )}
        </CenteredBox>
      </Typography>
      <Menu
        id={`popover-${header}`}
        anchorEl={anchorEl}
        open={openPopoverId === header}
        onClose={handlePopoverClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ width: "70%" }}
      >
        {kycStatus.map((status) => (
          <MenuItem
            key={`menu-item-popover-${status}`}
            aria-label={`${status}`}
            value={status}
            onClick={() => handleSelectedStatus(status)}
            selected={statuses && statuses[0] === status}
          >
            <StatusCircle
              status={`${camelCase(status)}`}
              text={translate("profile:profileStatus." + status)}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
